export function Divider() {

  return (
    <div className="my-3 h-[3px] w-[30px] mx-auto rounded-lg" style={{
      background: 'linear-gradient(to right, #f32170,#ff6b08, #cf23cf)',
    }}/>
  );
}
